import { z } from "zod";
export const CSSPropertyEnum = z.enum([
    "color",
    "backgroundColor",
    "borderColor",
    "borderTopColor",
    "borderBottomColor",
    "borderRightColor",
    "borderLeftColor",
    "textShadow",
    "boxShadow"
]);
// Single page style object
export const PageStyle = z.object({
    from: z.string(),
    to: z.string(),
    property: CSSPropertyEnum
});
// An array of page styles
export const PageStyles = z.array(PageStyle);
